import { Map as map } from 'immutable';
const C = require("../constants");

function SectionSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.SECTION_SELECT:
            return action.data;
        default:
            return state;
    }
};

export default SectionSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/SectionSelectReducer.js